import React from 'react';
import Adjuster from '../assets/images/user-check.svg';

export default () => {
  return <img src={Adjuster} alt="" />;
};
